import React, { ReactElement } from 'react';

import Link from 'next/link';

import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { MaxWidthStyled, mq } from '@hangar31/rc-layout';
import LogoSVG from '@OnArk/SVGs/Logo';

const FooterStyled = styled.footer(
  ({ theme }) => css`
    z-index: 100;

    padding: 8rem 0 4rem;

    color: ${theme.colors.white};
    font-size: 1.4rem;

    text-align: center;

    background-color: ${theme.colors.black};
    a {
      color: ${theme.colors.white};
      &:hover {
        color: ${theme.colors.secondary};
      }
    }
    p {
      margin: 0;
    }
  `
);

function Footer(_props: Record<string, never>): ReactElement {
  return (
    <FooterStyled>
      <LogoSVG fill="#fff" />
      <MaxWidthStyled
        flex
        padding
        css={mq({
          justifyContent: ['center', undefined, 'space-between'],
          marginTop: '2rem',
        })}
        justify="space-between"
        top={2}
      >
        <p>
          &copy;&nbsp;
          {new Date().getFullYear()}
          &nbsp;Onark.App
        </p>
        <div>
          <Link css={{ marginRight: '5rem' }} href="/terms-of-service">
            Terms of Service
          </Link>
          <Link href="/privacy-policy">Privacy Policy</Link>
        </div>
      </MaxWidthStyled>
    </FooterStyled>
  );
}

export default Footer;
